import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const CircleUpIcon = createIcon(
  'CircleUp',
  <path d="M12,2 C17.52,2 22,6.48 22,12 C22,17.52 17.52,22 12,22 C6.48,22 2,17.52 2,12 C2,6.48 6.48,2 12,2 Z M11.29,9.21 L8.21,12.29 C7.82,12.68 7.82,13.32 8.21,13.71 C8.6,14.1 9.23,14.1 9.62,13.71 L12,11.33 L14.38,13.71 C14.77,14.1 15.4,14.1 15.79,13.71 C16.18,13.32 16.18,12.68 15.79,12.29 L12.71,9.21 C12.32,8.82 11.69,8.82 11.29,9.21 Z" />
);

export default CircleUpIcon;
